import { axiosInstance } from "../_base/axios.instance"
import { API_URL } from "../../constants"

export async function checkEmail({ email }) {
    await axiosInstance.get(
      `${API_URL}/auth/checkEmail/${email}`,
      {}
    )
  };
